export default "/images/vendor/flag-icons/flags/1x1/ae.svg?e982ce1a46db65259241bb5b37266864";